// Import System requirements
import Vue from 'vue'
import VueRouter from 'vue-router'

import { sync } from 'vuex-router-sync'
import routes from './routes'
import store from './store'
import cognito from './cognito'
// import chatbot from './chatbot.js'
// Import Helpers for filters
import { domain, count, prettyDate, pluralize } from './filters'

// Import Views - Top level
import AppView from './components/App.vue'
import PingPong from './components/views/pingpong.js'
import Simplert from './components/views/Simplert.js'
// import VueGoodTable from './components/views/datalist.js'
import VueLogger from 'vuejs-logger'
// import CognitoAuth from './cognito/cognito'
// import config from './config/index.js'

const isProduction = process.env.NODE_ENV === 'production'
const options = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
}
Vue.use(VueLogger, options)
// Import Install and register helper items
Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('prettyDate', prettyDate)
Vue.filter('pluralize', pluralize)
// require('../node_modules/vue2-simplert-plugin/dist/vue2-simplert-plugin.css')
Vue.use(VueRouter, cognito, PingPong, Simplert)
// export default new CognitoAuth()
// Routing logic
var router = new VueRouter({
  routes: routes,
  mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

// test

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  // alert('thestt')
  // window.console.log('Transition', transition)
  // cognito
  //   .isAuthenticated()
  //   .then(session => {
  //     next()
  //   })
  //   .catch(session => {
  //     next({
  //       path: '/login'
  //     })
  //   })
  if (to.auth && to.router.app.$store.state.token === 'null') {
    // if (window.localStorage.getItem('user') === null) {
    window.console.log('Not authenticated')
    next({
      path: '/login'
    })
  } else {
    next()
  }
})

sync(store, router)
// var ComponentClass = Vue.extend(PingPong)
// var instance = new ComponentClass()
// instance.$mount()
// Start out app!
// eslint-disable-next-line no-new
new Vue({
  el: '#root',
  router: router,
  store: store,
  cognito,
  PingPong,
  Simplert,
  render: h => h(AppView)
})
// Check local storage to handle refreshes
if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null'
  var localUser = localUserString

  if (localUser && store.state.user !== localUser) {
    store.commit('SET_USER', localUser)
    store.commit('SET_TOKEN', window.localStorage.getItem('token'))
  }
}



// WEBPACK FOOTER //
// ./src/main.js